export const DEFAULT_NOTIFICATION_DURATION = 6000;
export const DEFAULT_NOTIFICATION_POSITION = 'top-right';
